import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, ShoppingBag, UtensilsCrossed, CalendarCheck, ShieldAlert } from "lucide-react";

const TABS = [
  { id: "home", label: "Home", icon: Home, path: "/home" },
  { id: "products", label: "Shop", icon: ShoppingBag, path: "/products" },
  { id: "recipes", label: "Recipes", icon: UtensilsCrossed, path: "/recipes" },
  { id: "bookings", label: "Consult", icon: CalendarCheck, path: "/booking" },
  { id: "admin", label: "Admin", icon: ShieldAlert, path: "/admin" },
];

export const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/products") return location.pathname.startsWith("/products");
    if (path === "/recipes") return location.pathname.startsWith("/recipes");
    if (path === "/admin") return location.pathname.startsWith("/admin");
    return location.pathname === path;
  };

  return (
    <nav className="absolute bottom-0 left-0 right-0 bg-white/90 dark:bg-emerald-950/90 backdrop-blur-xl border-t border-slate-200/80 dark:border-emerald-800/60 px-2 py-2 pb-3 flex justify-around items-center z-50 shadow-[0_-4px_20px_rgba(0,0,0,0.06)]">
      {TABS.map((tab) => {
        const active = isActive(tab.path);
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            data-testid={`bottom-nav-${tab.id}`}
            onClick={() => navigate(tab.path)}
            className={`flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-xl transition-all duration-200 ${
              active
                ? "text-emerald-700 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/50 scale-105"
                : "text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300"
            }`}
          >
            <Icon className="w-5 h-5" strokeWidth={active ? 2.5 : 2} />
            <span className={`text-[10px] ${active ? "font-bold" : "font-medium"}`}>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
};
